import { Box, Heading, Text } from '@chakra-ui/react';
import { fontSize } from '@constants/styles';
import CallUsButton from '../../interactive/CallUsButton';
import HeroContainer from '../../pages/products/common/ProductHero/HeroContainer';

const Hero = () => (
  <HeroContainer>
    <Box pt={[1, 20]} pb={[0, 5]}>
      <Heading as="h1" fontSize={fontSize.hero} mb={5}>
        Just moved? We'll help you sort out Medicare.
      </Heading>
      <Heading fontSize="25px" mb={5}>
        Your unbiased guide to Medicare Parts A & B, Medicare Supplements, and Medicare Advantage. Our agents are
        experts in helping folks who just moved figure out their coverage.
      </Heading>
      <Box pb={[5, 8]}>
        <span className="add-scribble-below ">
          <Text fontSize={['xl', '2xl', '3xl']} color="blue.400" fontWeight={700} className="tracking-in-expand">
            100% free.
          </Text>
        </span>
      </Box>
      <CallUsButton />
    </Box>
  </HeroContainer>
);

export default Hero;
